import React from 'react'
import PropTypes from 'prop-types'
import queryString from 'query-string'

import CategoryList from './CategoryList'
import ScoreCalculator from './calculator/ScoreCalculator'
import xhr from './xhr'

const AppContext = React.createContext()

export class AppContextProvider extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loadingApp: true,
            updatingList: false,
            toggleShare: false,
            slideIndex: 0,
            list: [],
            isActive: '',
        }
        this.getContext = this.getContext.bind(this)
        this.toggleShareLightboxOn = this.toggleShareLightboxOn.bind(this)
        this.toggleShareLightboxOff = this.toggleShareLightboxOff.bind(this)
        this.onUpdate = this.onUpdate.bind(this)
        this.reset = this.reset.bind(this)
        this.setContextState = this.setContextState.bind(this)
    }

    componentDidMount() {
        const { id } = queryString.parse(window.location.search)

        if (id) {
            xhr.get(`/wp-json/rankers/v1/gameofthrones/get?hash=${id}`)
                .then(result => JSON.parse(result.settings))
                .then(data => {
                    if (id) {
                        this.scoreCalculator = new ScoreCalculator(data)
                        this.scoreCalculator.onUpdate(this.onUpdate)
                        this.scoreCalculator.update()
                    }
                    this.setState({
                        loadingApp: false,
                    })
                })
                .catch(e => console.log(e))
        } else {
            this.scoreCalculator = new ScoreCalculator(CategoryList)
            this.scoreCalculator.onUpdate(this.onUpdate)
            this.setState({
                loadingApp: false,
            })
        }
    }

    onUpdate() {
        this.setState({ list: this.scoreCalculator.calculateScore(), updatingList: true })
        setTimeout(() => {
            this.setState({ updatingList: false })
        }, 100)
        setTimeout(() => {
            this.setState({ isActive: '' })
        }, 3000)
    }

    getContext() {
        return {
            ...this.state,
            scoreCalculator: this.scoreCalculator,
            toggleShareLightboxOn: this.toggleShareLightboxOn,
            toggleShareLightboxOff: this.toggleShareLightboxOff,
            reset: this.reset,
            setContextState: this.setContextState,
        }
    }

    setContextState(update) {
        this.setState(update)
    }

    reset() {
        const url = new URL(window.location.href)
        window.location.href = `${url.origin}${url.pathname}`
    }

    toggleShareLightboxOn() {
        this.setState({
            toggleShare: true,
        })
    }

    toggleShareLightboxOff() {
        this.setState({
            toggleShare: false,
        })
    }

    render() {
        const { render } = this.props
        const context = this.getContext()
        return <AppContext.Provider value={context}>{render(context)}</AppContext.Provider>
    }
}

AppContextProvider.propTypes = {
    render: PropTypes.func.isRequired,
}

export const withAppContext = Component => props => (
    <AppContext.Consumer>{appContext => <Component {...props} appContext={appContext} />}</AppContext.Consumer>
)



// WEBPACK FOOTER //
// ./src/utils/AppContext.js